import { render, staticRenderFns } from "./chateau-margaux.vue?vue&type=template&id=02bf130c&scoped=true"
import script from "./chateau-margaux.vue?vue&type=script&lang=js"
export * from "./chateau-margaux.vue?vue&type=script&lang=js"
import style0 from "./chateau-margaux.vue?vue&type=style&index=0&id=02bf130c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bf130c",
  null
  
)

export default component.exports